

import { SVGProps } from 'react';

const ChatBox = ({
    width = 18,
    height = 18,
    fill = '#2A2A2A',
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 14.375L5.375 12.5H15.5V4.5H3.5V14.375ZM2.74175 16.95C2.56392 16.95 2.39583 16.8833 2.2375 16.75C2.07917 16.6167 2 16.4333 2 16.2V4.5C2 4.0875 2.14692 3.73433 2.44075 3.4405C2.73442 3.14683 3.0875 3 3.5 3H15.5C15.9125 3 16.2657 3.14683 16.5595 3.4405C16.8532 3.73433 17 4.0875 17 4.5V12.5C17 12.9125 16.8532 13.2656 16.5595 13.5593C16.2657 13.8531 15.9125 14 15.5 14H6L3.275 16.725C3.19167 16.8083 3.10417 16.8667 3.0125 16.9C2.92083 16.9333 2.83058 16.95 2.74175 16.95Z" fill="#00AEC7" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 15V16.5C7 16.9125 7.14683 17.2656 7.4405 17.5593C7.73433 17.8531 8.0875 18 8.5 18H18L20.725 20.725C20.8083 20.8083 20.8958 20.8667 20.9875 20.9C21.0792 20.9333 21.1694 20.95 21.2583 20.95C21.4361 20.95 21.6042 20.8833 21.7625 20.75C21.9208 20.6167 22 20.4333 22 20.2V8.5C22 8.0875 21.8531 7.73433 21.5592 7.4405C21.2656 7.14683 20.9125 7 20.5 7H18V13C18 14 17 15 16 15H7Z" fill="#00AEC7" />
    </svg>

);

export default ChatBox;




